



























































import { Vue, Component, Prop } from "@/shared/vuepack";
import AccountBalanceWidget from "@/shared/widgets/AccountBalanceWidget.vue";
import ContributionsGraphWidget from "@/shared/components/contribution/ContributionsGraphWidget.vue";
import AccountHolderProfile from "./AccountHolderProfile.vue";
import AccountHolderCredentials from "./AccountHolderCredentials.vue";
import AccountHolderBilling from "./AccountHolderBilling.vue";
import AccountHolderUserSystemId from "./AccountHolderUserSystemId.vue";
import AccountHolderBankAccountHolds from "./AccountHolderBankAccountHolds.vue";
import { Permission, AuthenticationProvider } from "@/shared/types";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";

@Component({
  components: {
    AccountBalanceWidget,
    ContributionsGraphWidget,
    AccountHolderProfile,
    AccountHolderCredentials,
    AccountHolderBilling,
    AccountHolderUserSystemId,
    AccountHolderBankAccountHolds
  }
})
export default class extends Vue {

  rolePermissionStore = useRolePermissionsStore();
  custodianSettingsStore = useCustodianSettingsStore();

  @Prop()
  username: string;

  @Prop()
  partnerId: number;

  canEditProfile = false;
  handleCredentialsLoaded (profile) {
    if (profile) {
      this.canEditProfile = (profile.status === "staged" || profile.isCredentialed === false) && profile.provider === AuthenticationProvider.Okta;
    }
  }

  get hasAccountInfoReadPermision () {
    return this.rolePermissionStore.userHasPartnerPermission(Permission.HsaAccountInfoRead, this.partnerId);
  }

  get bankAccountHoldsVisible (): boolean {
    return this.custodianSettingsStore.displayBankAccountHolds;
  }
}
